var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92026 13.2719L14.1257 8.39867C14.4908 7.97399 14.6958 7.39952 14.6958 6.80071C14.6958 6.20191 14.4908 5.62743 14.1257 5.20276L9.92026 0.329556C9.73659 0.118477 9.48814 0 9.22916 0C8.97018 0 8.72173 0.118477 8.53806 0.329556C8.44618 0.434911 8.37325 0.560255 8.32349 0.698359C8.27372 0.836462 8.2481 0.984591 8.2481 1.1342C8.2481 1.28381 8.27372 1.43194 8.32349 1.57004C8.37325 1.70815 8.44618 1.83349 8.53806 1.93885L11.7632 5.66741L0.98007 5.66741C0.720082 5.66741 0.470743 5.78681 0.286903 5.99935C0.103065 6.21188 -0.000213623 6.50014 -0.000213623 6.80071C-0.000213623 7.10128 0.103065 7.38954 0.286903 7.60208C0.470743 7.81461 0.720082 7.93402 0.98007 7.93402L11.7632 7.93402L8.53806 11.6626C8.35347 11.8745 8.24925 12.1625 8.24833 12.4632C8.24741 12.764 8.34987 13.0528 8.53316 13.2662C8.71645 13.4796 8.96556 13.6001 9.2257 13.6012C9.48583 13.6022 9.73567 13.4838 9.92026 13.2719Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrowRightWhite.904bc70d7216c8e22fbe1ca60dcce1ed.svg";
export { ForwardRef as ReactComponent };